import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { fetchContentPageById } from 'core/actions/ocapi';
import EmailOptInTrigger from 'core/modules/EmailOptInTrigger/EmailOptInTrigger';
import HolidayBorder from 'core/modules/HolidayBorder/HolidayBorder';

import { updateApp } from 'core/modules/App/actions';
import { selectExtraRewardsPage } from 'core/selectors/app';
import PublicBonusTracker from 'core/modules/PublicBonusTracker/PublicBonusTracker';
import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';
import DynamicPageComponent from './components/DynamicPageComponent/DynamicPageComponent';

import {
  selectDynamicRewardsPageContentConfig,
  selectDynamicRewardsPageContentInfo,
  selectDynamicRewardsPageContentIsLoading,
  selectDynamicRewardsPageContentIsLoaded,
} from './selectors';

export function DynamicRewardsPageContent() {
  const config = useSelector(selectDynamicRewardsPageContentConfig);
  const pageContent = useSelector(selectDynamicRewardsPageContentInfo) || {};
  const isLoaded = useSelector(selectDynamicRewardsPageContentIsLoaded);
  const isLoading = useSelector(selectDynamicRewardsPageContentIsLoading);
  const extraRewardsPage = useSelector(selectExtraRewardsPage);
  const { slots = [] } = pageContent;
  const { components = [] } = slots[0] || {};
  const { dynamicPage } = useParams();
  const dispatch = useDispatch();
  const { bonusTrackerOffer } = useGetBonusOffers();

  useEffect(() => {
    if (!isLoading && !isLoaded) {
      const pageNameArray = dynamicPage.split('.htm');
      const pageId = pageNameArray[0];

      if (!isEmpty(pageId)) {
        const { api: { params, options } = {} } = config;
        dispatch(fetchContentPageById(pageId, params, options));
      }
    }
  }, []);

  useEffect(() => {
    if (isLoaded && pageContent) {
      // When the dynamic page response is returned then the store page related data should be updated
      // according to can.js implementation
      const { pageId } = pageContent;
      if (pageId !== 0) {
        dispatch(updateApp({
          app: {
            page: {
              // initially page id value is genericContentPage id
              // should be updated with page id from dynamic page response
              id: pageId,
            },
          },
        }));
      }
    }
  }, [isLoaded, pageContent.length]);

  if (isEmpty(components)) {
    return null;
  }

  const isExtraRewardsPage = window.location.href.includes(extraRewardsPage);
  const shouldShowAutomaticPublicBonus = bonusTrackerOffer?.isAutomaticPlacement && isExtraRewardsPage;

  return (
    <div className="mn_dynamicRewardsPage" data-test="dynamic-rewards-page">
      <HolidayBorder />
      <PublicBonusTracker />
      <DynamicPageComponent components={components} shouldShowAutomaticPublicBonus={shouldShowAutomaticPublicBonus} />
      <EmailOptInTrigger />
    </div>
  );
}

export default DynamicRewardsPageContent;
